import { Component, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Customer } from '../dto/customer';
import { CustomerService } from '../service/customer.service';
import { NgFor, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { StateNotifyService } from '../../../common/state/service/state-notify.service';
import { UserEditRightService } from '../../../common/user-role/service/user-edit-right.service';

@Component({
  selector: 'dpi-customer-list',
  imports: [MatCardModule, MatIconModule, MatButtonModule, MatToolbarModule, NgFor],
  templateUrl: './customer-list.component.html',
  styleUrl: './customer-list.component.scss'
})
export class CustomerListComponent implements OnInit {
  customers: Customer[] = [];

  constructor(private customerService: CustomerService, private notifyService: StateNotifyService
    , private router: Router, private userRightService: UserEditRightService) {
    this.customerService.getAllCustomers()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: res => { 
          this.customers = res; 
          this.notifyService.updateAllCustomerList(this.customers);
          this.setCustomerIcon();
        },
        error: err => { console.log(err); }
      });
  }

  ngOnInit(): void {
  }

  private setCustomerIcon() {
    for(var customer of this.customers) {
      let hasEditRight = this.userRightService.getEditRight(customer.user_role);
      if (hasEditRight) {
        customer.icon = "icons/design.ico";
      } else {
        customer.icon = "icons/folder.ico";
      }
    }
  }

  public selectCustomer(selected: Customer) {
    this.notifyService.updateCustomerSelection(selected);

    let editRight = this.userRightService.getEditRight(selected.user_role);
    this.notifyService.updateUserEditRight(editRight);

    this.router.navigate(['customer-details']);
  }

}
